module.exports = __webpack_public_path__ + "img/周奇伟.c1855066.png";